'use client';

import React, { useState } from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import SubmissionModal from './submissionModal';
import { getSiteConfig } from '../../../siteConfig';
import { trackEvent } from '../../utils/tracking';

const FormWrapper = ({ blok, defaultValues }) => {
  // This ensures that the formValues object has the same keys as the form names,
  // and that selections and radio buttons are set to the first value by default.
  const formValueKeys = {};

  blok.forms.forEach((form) => {
    if (form.component === 'form_radiobuttons_wrapper') {
      formValueKeys[form.name] = form.radiobuttons[0].value;
    } else if (form.component === 'form_selector') {
      formValueKeys[form.name] = form.options[0].value;
    } else {
      if (defaultValues && defaultValues[form.name]) {
        formValueKeys[form.name] = defaultValues[form.name];
      } else {
        formValueKeys[form.name] = '';
      }
    }
  });

  const [formValues, setFormValues] = useState(formValueKeys);
  const [errors, setErrors] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSubmissionModal, setShowSubmissionModal] = useState(false);
  const submissionModalMessage = blok.submission_message;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors(null);
    setIsSubmitting(true);

    const formData = new FormData(e.target);
    var object = {};
    formData.forEach((value, key) => {
      // Reflect.has in favor of: object.hasOwnProperty(key)
      if (!Reflect.has(object, key)) {
        object[key] = value;
        return;
      }
      if (!Array.isArray(object[key])) {
        object[key] = [object[key]];
      }
      object[key].push(value);
    });
    object.recipient = blok.recipient_email;
    object.subject = blok.subject;
    object.market = getSiteConfig().ethelMarket;

    var json = JSON.stringify(object);

    fetch('/.netlify/functions/form', {
      method: 'POST',
      body: json,
    })
      .then(() => {
        setIsSubmitting(false);
        setShowSubmissionModal(true);
        trackEvent('lead_generation', { form_name: blok.name });
      })
      .catch((error) => {
        alert(error);
        setIsSubmitting(false);
      });
    //}
  };

  // Tailwind CSS classes --- --- --- --- --->
  const formWidth = {
    '50%': 'col-span-12 sm:col-span-6',
    '66%': 'col-span-12 md:col-span-8',
    '100%': 'col-span-12',
  };
  // >--- --- --- --- --- Tailwind CSS classes

  return (
    <div
      className={`relative flex flex-col ${formWidth[blok.form_width]} ${
        blok.padding_vertical ? 'pt-8 -mb-4' : 'py-0'
      }`}
      {...storyblokEditable(blok)}
    >
      {!showSubmissionModal && (
        <form
          className={`flex flex-row flex-wrap grid grid-cols-12 items-left w-full`}
          name={blok.name}
          method="post"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="form-name" value={blok.name} />
          {blok.forms.map((nestedBlok) => {
            return (
              <StoryblokComponent
                blok={nestedBlok}
                key={nestedBlok._uid}
                handleInputChange={handleInputChange}
                formValue={formValues[nestedBlok.name]}
              />
            );
          })}
          <div className="w-full col-span-12 px-2 md:px-4 mt-4">
            <StoryblokComponent
              blok={blok.submit_button[0]}
              key={blok.submit_button[0]._uid}
              isSubmitting={isSubmitting}
            />
          </div>
        </form>
      )}
      {showSubmissionModal && (
        <SubmissionModal
          message={submissionModalMessage}
          submitError={errors}
        />
      )}
    </div>
  );
};

export default FormWrapper;
